import urls from 'constants/urls.json';
import { getPdf } from 'modules/api';

export const PDF_DOWNLOADS_REQUEST = 'PDF_DOWNLOADS_REQUEST';
export const PDF_DOWNLOADS_RECEIVED = 'PDF_DOWNLOADS_RECEIVED';

export const requestPdfDownloads = () => {
  return { type: PDF_DOWNLOADS_REQUEST };
};

export const receivePdfDownloads = (pdfDownloads) => {
  return { type: PDF_DOWNLOADS_RECEIVED, pdfDownloads };
};

export const fetchPdfDownloads = (filters) => {
  return async (dispatch) => {
    dispatch(requestPdfDownloads());

    const files = await getPdf(urls['pdf'], filters, filters.view);

    dispatch(receivePdfDownloads(files));
  };
};
